import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tab_type_end",
  "use": "icon-tab_type_end-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-tab_type_end\">\r\n  <path id=\"icon-tab_type_end_关联区-强制结束\" class=\"cls-1\" d=\"M91.333,85.333a6,6,0,1,0,6,6A6.018,6.018,0,0,0,91.333,85.333Zm2.4,6.6h-4.8a.6.6,0,1,1,0-1.2h4.8a.6.6,0,1,1,0,1.2Z\" transform=\"translate(-85.333 -85.333)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol